
import { Link } from 'react-router-dom';

export default function ContactCTA() {
  return (
    <section
      id="contact"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <img
        src="https://public.readdy.ai/ai/img_res/3043008badc032f46e80878416dc5791.jpg"
        alt="İletişim"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>

      <div className="relative z-10 text-center px-8 max-w-4xl mx-auto">
        <h2
          className="font-serif text-6xl font-bold text-white mb-6 tracking-wide uppercase"
          style={{ letterSpacing: '0.1em' }}
        >
          Tesis Güvenlik Belgenizi
          <br />
          Almaya Hazır mısınız?
        </h2>

        <p className="text-2xl text-white/90 mb-8 leading-relaxed">
          Ücretsiz ön değerlendirme ve danışmanlık hizmeti için hemen iletişime
          geçin. MSB, NATO ve Özel Tesis Güvenlik Belgesi süreçlerinizde
          profesyonel destek alın.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Link
            to="/ucretsiz-on-degerlendirme"
            className="inline-flex items-center gap-4 bg-white text-gray-900 px-10 py-5 rounded-full text-lg font-bold hover:bg-gray-100 transition-all cursor-pointer shadow-2xl hover:shadow-3xl whitespace-nowrap"
          >
            <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
              <i className="ri-calendar-check-line text-white text-xl"></i>
            </div>
            <span className="uppercase tracking-wide">
              Ücretsiz Ön Değerlendirme
            </span>
            <i className="ri-arrow-right-up-line text-2xl"></i>
          </Link>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white">
          <a
            href="tel:+903126660636"
            className="flex items-center gap-3 hover:text-orange-500 transition-colors cursor-pointer"
          >
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-phone-line text-xl"></i>
            </div>
            <span className="text-lg font-semibold">0312 666 06 36</span>
          </a>

          <a
            href="https://wa.me/903126660636"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 hover:text-orange-500 transition-colors cursor-pointer"
          >
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-whatsapp-line text-xl"></i>
            </div>
            <span className="text-lg font-semibold">WhatsApp ile İletişim</span>
          </a>
        </div>
      </div>
    </section>
  );
}
